module.exports = __webpack_public_path__ + "img/27.6141cb46.jpg";